export const TEMPORARILY_UNAVAILABLE = 'Sorry, this service is temporarily unavailable. Please check back later.'
